"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var next_intl_1 = require("next-intl");
var image_1 = __importDefault(require("next/image"));
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var Dropdown = function (_a) {
    var title = _a.title, value = _a.value, onChange = _a.onChange, options = _a.options, _b = _a.withSearch, withSearch = _b === void 0 ? false : _b;
    var t = (0, next_intl_1.useTranslations)();
    var _c = (0, react_1.useState)(false), isOpen = _c[0], setIsOpen = _c[1];
    var openDropdown = (0, react_1.useCallback)(function () { return setIsOpen(!isOpen); }, [setIsOpen, isOpen]);
    var _d = (0, react_1.useState)(''), search = _d[0], setSearch = _d[1];
    var translateLocale = (0, swr_hooks_1.useLocaleTranslations)();
    var closeDropdown = (0, react_1.useCallback)(function () {
        setIsOpen(false);
        setSearch('');
    }, [setIsOpen]);
    var ref = (0, react_1.useRef)(null);
    (0, apps_shared_1.useClickOutside)(closeDropdown, ref);
    var handleOnChange = function (id) {
        onChange(id);
        closeDropdown();
    };
    var filteredOptions = options.filter(function (o) { var _a, _b; return (_b = (_a = o === null || o === void 0 ? void 0 : o.title) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(search === null || search === void 0 ? void 0 : search.toLowerCase()); });
    var filteredOptionsWithALl = (0, react_1.useMemo)(function () { return __spreadArray([{ id: 'all', title: t('all') }], filteredOptions, true); }, [t, filteredOptions]);
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, "  ").concat(withSearch ? styles_module_scss_1.default.withSearch : ''), ref: ref },
        react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.main, " ").concat(isOpen ? styles_module_scss_1.default.isOpen : ''), onClick: openDropdown },
            react_1.default.createElement("span", { className: styles_module_scss_1.default.value }, translateLocale(value || title)),
            react_1.default.createElement("span", { className: "".concat(styles_module_scss_1.default.icon, " ").concat(isOpen ? styles_module_scss_1.default.rotate : '') },
                react_1.default.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    react_1.default.createElement("path", { d: "M2.45686 5.51576C2.39322 5.45561 2.31835 5.40859 2.23653 5.37738C2.15471 5.34617 2.06754 5.33138 1.98001 5.33386C1.89247 5.33633 1.80628 5.35603 1.72636 5.39181C1.64644 5.4276 1.57434 5.47878 1.5142 5.54242C1.45405 5.60607 1.40703 5.68094 1.37582 5.76276C1.34461 5.84458 1.32982 5.93174 1.3323 6.01928C1.33477 6.10681 1.35447 6.193 1.39025 6.27293C1.42604 6.35285 1.47722 6.42494 1.54086 6.48509L7.54086 12.1518C7.66464 12.2688 7.82852 12.334 7.99886 12.334C8.16921 12.334 8.33308 12.2688 8.45686 12.1518L14.4575 6.48509C14.5226 6.42534 14.5751 6.35326 14.612 6.27305C14.649 6.19283 14.6696 6.10607 14.6728 6.01781C14.6759 5.92954 14.6615 5.84154 14.6303 5.7589C14.5991 5.67626 14.5519 5.60064 14.4912 5.53642C14.4306 5.47221 14.3578 5.42069 14.2771 5.38484C14.1964 5.349 14.1093 5.32955 14.021 5.32763C13.9327 5.3257 13.8449 5.34134 13.7627 5.37364C13.6805 5.40594 13.6056 5.45424 13.5422 5.51576L7.99886 10.7504L2.45686 5.51576Z" })))),
        isOpen && react_1.default.createElement("div", { className: styles_module_scss_1.default.blur, onClick: closeDropdown }),
        isOpen && (react_1.default.createElement(react_1.Suspense, { fallback: false },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
                withSearch && (react_1.default.createElement("div", { className: styles_module_scss_1.default.searchInput },
                    react_1.default.createElement("input", { placeholder: t('search'), onChange: function (e) { return setSearch(e.target.value); } }),
                    react_1.default.createElement(image_1.default, { src: "/img/game-filters/search.svg", width: 16, height: 16, alt: "Search icon" }))),
                react_1.default.createElement("ul", null, filteredOptionsWithALl.map(function (o) { return (react_1.default.createElement("li", { key: o.id, onClick: function () {
                        if (o.id === 'all')
                            handleOnChange(undefined);
                        else
                            handleOnChange(o.id);
                    } }, translateLocale(o === null || o === void 0 ? void 0 : o.title))); })))))));
};
exports.default = Dropdown;
